(() => {
  const INTERVAL = 5000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.pcbcReady) return;
    root.dataset.pcbcReady = 'true';
    const track = root.querySelector('[data-pcbc-track]');
    if (!track) return;

    const step = () => {
      const card = track.querySelector('.pcbc-reviews__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const next = () => (atEnd() ? track.scrollTo({ left: 0 }) : track.scrollBy({ left: step() }));
    const prev = () => (track.scrollLeft <= 4 ? track.scrollTo({ left: track.scrollWidth }) : track.scrollBy({ left: -step() }));

    root.querySelector('[data-pcbc-next]')?.addEventListener('click', next);
    root.querySelector('[data-pcbc-prev]')?.addEventListener('click', prev);

    // "Read more" only on cards whose text is actually clamped; re-checked when the width changes.
    const cards = [...root.querySelectorAll('.pcbc-reviews__card')];
    const updateMore = () => {
      cards.forEach((card) => {
        if (card.classList.contains('is-expanded')) return;
        const text = card.querySelector('[data-pcbc-text]');
        const more = card.querySelector('[data-pcbc-more]');
        if (text && more) more.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    };
    cards.forEach((card) => {
      const more = card.querySelector('[data-pcbc-more]');
      more?.addEventListener('click', () => {
        const expanded = card.classList.toggle('is-expanded');
        more.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
    updateMore();
    new ResizeObserver(updateMore).observe(track);

    if (root.dataset.autoplay !== 'true' || reducedMotion) return;
    let paused = false;
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    setInterval(() => {
      if (!paused && !document.hidden) next();
    }, INTERVAL);
  }

  const initAll = () => document.querySelectorAll('[data-pcbc-reviews]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
